import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Route, Switch} from 'react-router-dom'
import Home from './Home'


class Dashboard extends PureComponent {
  render() {
    return (
      <Switch>
        <Route path="/dashboard" exact component={Home} />
   
      </Switch>
    )
  }
}

Dashboard.propTypes = {
  //label: PropTypes.string,
};

const styles = {};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/screens/dashboard/dasboard.js